import { Notification } from '@codeparva/ui-components-library';
import React from 'react';

export const AutoPayDisabledNotification = ({ handleClick, status }: any) => {
  return (
    <div className="is-flex is-justify-content-center is-align-content-center pb-4">
      <Notification className={`${status ? 'is-success' : 'is-warning'}`}>
        <button className="delete" onClick={() => handleClick()}></button>
        <span>
          {status
            ? 'Autopay disabled successfully'
            : 'Something went wrong.  Please try again.'}
        </span>
      </Notification>
    </div>
  );
};
